import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OnboardingBodyActivities, OnboardingGraphicActivities} from './onboarding-activities';
import {OnboardingBodyDirection, OnboardingGraphicDirection} from './onboarding-direction';
import {OnboardingBodyOtherSteps, OnboardingGraphicOtherSteps} from './onboarding-other-steps';
import {OnboardingBodyWizardIntro, OnboardingGraphicWizardIntro} from './onboarding-wizard-intro';

const FAKE_SAVE_DELAY = 2000;

type Props = {
    onClose: () => void;
    completeWizard: () => void;
};

type State = {
    isSaving: boolean;
};

// Just a standin until we have real pages
const pages = [
    {
        body: <OnboardingBodyWizardIntro />,
        art: {background: colors.yellow, image: () => <OnboardingGraphicWizardIntro />},
    },
    {
        body: <OnboardingBodyDirection />,
        art: {background: colors.yellow, image: () => <OnboardingGraphicDirection />},
    },
    {
        body: <OnboardingBodyActivities />,
        art: {background: colors.yellow, image: () => <OnboardingGraphicActivities />},
    },
    {
        body: <OnboardingBodyOtherSteps />,
        art: {background: colors.yellow, image: () => <OnboardingGraphicOtherSteps />},
    },
];

export class WizardComponent extends React.PureComponent<Props, State> {
    constructor() {
        // @ts-expect-error
        super();

        this.state = {
            isSaving: false,
        };
    }

    render() {
        return (
            <OnboardingModal
                // @ts-expect-error
                pages={pages}
                onClose={this.props.onClose}
                onFinish={this.handleFinish}
                firstButtonText='Let’s go!'
                lastButtonText={this.state.isSaving ? 'Saving…' : 'Finish'}
            />
        );
    }

    handleFinish = () => {
        // If we're already "saving", do nothing
        if (this.state.isSaving) return;

        this.setState({
            isSaving: true,
        });

        // Pretend like it takes a while to calculate this complicated sales process
        setTimeout(() => {
            this.props.completeWizard();
        }, FAKE_SAVE_DELAY);
    };
}
